import React, { useEffect, useState } from 'react'
import Avatar from 'react-avatar';
import { useHistory ,Redirect} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { rewardRequest } from '../../../data/reducers/referral.reducer';
import { createRewardItem } from '../../../data/reducers/admin.reducer';
import { toast } from 'react-toastify';

const PlanReward = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [compensation, setCompensation] = useState("");
    const [cart, setCart] = useState([]);
    const [quantity, setQuantity] = useState(0);
    const loggedIn = useSelector((state) => state.authReducer).loggedIn;

    const goPrevPage = () => {
        history.goBack();
    }

    window.onbeforeunload = function () {
        return "Data will be lost if you leave the page, are you sure?";
    };

    const request = useSelector(state => state.referralReducer).rewardRequest;
    const compensations = useSelector(state => state.adminReducer).rewardConfigList ?.filter(item => item.status);
    console.log('compensations: ', compensations);
    console.log('request : ', request);

    const [remainingPoints, setRemainingPoints] = useState(request ?.pointsAcceptedForReward);

    const getTotalPoints = () => {
        let total_points = 0;
        for (let item of cart) {
            total_points = item.rewardPoints * item.quantity + total_points;
        }
        console.log('total_points: ', total_points);
        return total_points;
    }

    const handleCompensationSelect = (e) => {
        const reward_item = compensations.filter(item => item._id == e.target.value)[0];
        setCompensation(reward_item);
    }

    const removeItemFromCart = (_id) => {
        console.log('_id: ', _id);
        const deleted_cart = cart.filter(item => item._id != _id);
        console.log('deleted_cart: ', deleted_cart);
        setCart(deleted_cart);
    }

    const handleAddToCart = () => {
        if (compensation == "") {
            return toast.error("Please select some Compensation");
        }
        if (quantity == 0) {
            return toast.error(`Please enter some ${compensation ?.measure.toLowerCase()} .. !`);
        }
        if (remainingPoints < parseInt(compensation.rewardPoints) * parseInt(quantity)) {
            return toast.error('Not enough points');
        }

        console.log('[...cart, { ...compensation, quantity }] : ', [...cart, { ...compensation, quantity }]);
        // const total_points = [...cart, { ...compensation, quantity }].reduce((a, total) => {
        //     console.log('a: ', a);
        //     return parseInt(a.rewardPoints) + total;
        // }, 0);

        setCart([...cart, { ...compensation, quantity }]);
        setQuantity(0);
        setCompensation("");
        const dropdown_rewards = document.getElementById("dropdown-reward");
        dropdown_rewards.selectedIndex = 0;
        console.log('[...cart, compensation] : ', [...cart, compensation]);
    }

    const finalizeReward = async () => {
        if (remainingPoints != 0) {
            return toast.error("Partial point redeemption not allowed .. !");
        }
        const response = await dispatch(createRewardItem({ _id: request._id, rewards: cart }))
        if (response.payload.isSuccessful) {
            history.push('/config');
            setCart([]);
            return toast("Reward Created Successfully");
        }
    }

    useEffect(() => {
        const points = getTotalPoints();
        setRemainingPoints(parseInt(request ?.pointsAcceptedForReward) - parseInt(points));

    }, [cart]);

    useEffect(() => {
        console.log('props.history: ', props.history.location.state?.request);
        setRemainingPoints(props.history.location.state?.request.pointsAcceptedForReward) ;
        dispatch(rewardRequest({ request: props.history.location.state?.request }));

    }, []);
    if (loggedIn === false) {
        return <Redirect to="/"></Redirect>;
      }
    return (
        <div className='container my-3'>
            <div className='row'>
                <div className="col d-flex align-items-center">
                <div onClick={goPrevPage} class="btn btn-primary">Back</div>
                </div>
                <div className="col-12">
                    <div className="border rounded p-4 my-4">
                        <div className="row border-bottom pb-3">
                            <div className="col-md-5">
                                <div className="event-poster mx-auto border rounded-lg">
                                    <img className="img-fluid rounded-lg" src="../assets/images/thanksimg.png" />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className=" mt-3 mt-md-0">
                                    <div className='row mb-2'>
                                        <h5 className="text-secondary col-4 col-md-3 "> Name : </h5>
                                        <h5 className="col-8 col-md-9 text-capitalize" >{`${request ?.user.firstName} ${request ?.user.lastName}`}</h5>
                                    </div>
                                    <div className='row mb-2'>
                                        <h5 className="text-secondary col-4 col-md-3 "> Contact No : </h5>
                                        <h5 className="col-8 col-md-9 text-capitalize" >{`${request ?.user.mobileNumber}`}</h5>
                                    </div>
                                    <div className='row mb-2'>
                                        <h5 className="text-secondary col-4 col-md-3 ">UPI ID : </h5>
                                        <h5 className="col-8 col-md-9 text-capitalize" >{`${request ?.benificiaryUpiId}`}</h5>
                                    </div>
                                    <div className='row mb-2'>
                                        <h5 className="text-secondary col-4 col-md-3 "> Address : </h5>
                                        <h5 className="col-8 col-md-9 text-capitalize" >{`Some hardcode address as of now`}</h5>
                                    </div>
                                </div>
                                <div className="my-2 bprder-w2 border border-primary text-primary p-3 rounded" >
                                    <div className='row px-0 '>
                                        <h5 className="col-9 mb-0"> Total Points : </h5>
                                        <h5 className="col-3 text-capitalize mb-0 text-right" >{request?.pointsAcceptedForReward}</h5>
                                    </div>
                                </div>
                                <div className="text-sm-right mt-3">
                                    <h4>Remaining Points : {remainingPoints} pts.</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-7">

                            </div>
                            <div className="col-md-5"></div>
                        </div>

                        <div className='row mt-4 my-2 d-flex align-items-center'>
                            <div className="col-12">
                                <h4>Reward Structure</h4>
                            </div>
                            {
                                console.log('compensttion name : ', compensation ?.rewardName)
                            }
                            <div className='col-md-6 col-lg-5 mb-3 mb-md-0'>
                                <select defaultValue={compensation ?.rewardName} id="dropdown-reward" onChange={(e) => { handleCompensationSelect(e); console.log("value : ", e.target.value) }} className='custom-select form-control form-control-lg '>
                                    <option value="" class="dropdown-item">Select Compensation</option>

                                    {
                                        compensations ?.map(item => (
                                            <option value={item._id} class="dropdown-item">{item ?.rewardName} ({item.type}) ---  {item.rewardPoints} pts.</option>
                                        ))
                        }

                                </select>
                            </div>
                            <div className="col-lg-5 col-md-3 mb-3 mb-md-0">
                                {
                                    compensation != "" ?
                                        <div className=''>
                                            {
                                                compensation ?.measure == "AMOUNT" ?
                                                    // dynamic points rs conversion should be implemented
                                                    <>
                                                        <input className="form-control form-control-lg" onChange={(e) => { setQuantity(parseInt(e.target.value)) }} placeholder="Enter points .. " />
                                                    </> :
                                                    (
                                                        compensation ?.measure == "QUANTITY" ?
                                                            <div className=''>
                                                                <div className="">
                                                                    <input className='form-control form-control-lg' onChange={(e) => { setQuantity(parseInt(e.target.value)) }} placeholder="Quantity" type="number" min="0" />
                                                                </div>
                                                                {/* <div className="col text-center">
                                                        <Avatar src="data:image/jpeg;base64,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" />
                                                    </div> */}
                                                            </div> : null
                                        )
                                }
                                        </div> :
                                        null
                                }
                            </div>
                            <div className='col-lg-2 col-md-3 text-md-right mb-2 mb-md-0'>
                                <button className='btn btn-success' onClick={handleAddToCart}>
                                    Add To Cart
                    </button>
                            </div>
                        </div>
                        {
                            compensation == "CASH" ?
                                <div className="row">
                                    <div className="col"></div>
                                    <div className="col ml-4">
                                        <span style={{
                                            fontSize: "14px",
                                            fontWeight: "500"
                                        }} className='text-danger'>* Note - 1 pt. = 1/- </span>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div> : null
                        }

                        <div className="row">
                            <div className="col-md-12 mb-2 mt-4">
                                <h4>Cart</h4>
                            </div>
                            <div className="col-12">
                                <div className="table-responsive">
                                <table class="table">
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Quantity</th>
                                            <th scope="col">Product Type</th>
                                            <th scope="col">Points</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            cart ?.map((item, index) => {
                                                return (
                                                    <tr>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{item ?.rewardName}</td>
                                                        <td>{item.quantity}</td>
                                                        <td>{item.type}</td>
                                                        <td>{item.rewardPoints}</td>
                                                        <td>
                                                            <i
                                                                className="fa fa-trash font-weight-15 text-danger cursor-pointer"
                                                                onClick={() => removeItemFromCart(item._id)}
                                                            ></i>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                            }
                                    </tbody>
                                </table>
                                {
                                    cart.length == 0 ? <center><h4 className='text-muted'>No Reward in Cart</h4></center> :
                                        <div className="text-right">
                                            <button className='btn btn-warning' onClick={finalizeReward}>Finalize Reward</button>
                                        </div>
                                }    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlanReward;
